
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalFlag as ObiBuoySphericalFlagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-flag.js';
 
 
 

 
 export const ObiBuoySphericalFlag = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-flag',
   elementClass: ObiBuoySphericalFlagElement,
   events: {
     
   }
  });
 
 